import React from "react";

const Footer = () => {
  return (
    <footer style={{ padding: "0px 10px", textAlign: "center" }}>
      <p className="footer-text">
        Copyright © 2025, Powered By{" "}
        <a href="https://sstpro.org">sstpro.org</a>{" "}
      </p>
    </footer>
  );
};

export default Footer;
